/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const ChevronRightStrokeIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M8.40002 20.4L16.8 12L8.40002 3.59998" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </Icon>
  );
});

export { ChevronRightStrokeIcon };
